import { formatPrice } from "../../shared/js/formatPrice";
import { selectProductId } from "../../shared/js/selectProductId";

window.selectProductId = selectProductId;
window.formatPrice = formatPrice;

window._sqzl = window._sqzl || [];
window.sqzlPushWrapper = function (obj) {
  const lang = document.getElementsByTagName("html")[0].getAttribute("lang");
  if (obj.products && Array.isArray(obj.products)) {
    obj.products = obj.products.map((p) => {
      return {
        ...p,
        language: `${lang}-${lang.toUpperCase()}`,
      };
    });
  }
  window._sqzl.push({
    ...obj,
    language: `${lang}-${lang.toUpperCase()}`,
  });
};
